import { Button, Modal } from "@/components/ui";
import { FaAngleLeft } from "react-icons/fa6";
import { useFormik } from "formik";
import {BaseResponse} from "@/model/response/BaseResponse.ts";
import {useNavigate} from "react-router-dom";
import {RouteConstant} from "@/util/constant/RouteConstant";
import { ResetPassword, ResetPasswordRequestInit } from "@/model/request/auth/ResetPassword";
import { forgotPasswordSchema } from "@/utilities/validation/authSchema";
import { Textfield } from "@/components/ui/input/textfield";
import { useDispatch, useSelector } from "react-redux";
import { auth, AuthState } from "@/store/modules/auth";
import { useState } from "react";


export const ForgotPasswordForm = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [response, setResponse] = useState("");
  const [successResponse, setSuccessResponse] = useState('')
  const [successModal, setSuccessModal] = useState(false)
  const authState = useSelector<any>((state) => state.auth) as AuthState;
  
const dispatch = useDispatch()
  const handleSubmit = async (value: ResetPassword) => {
    await dispatch<any>(
        auth.action.reset({
            data: value,
            onSuccess: (response: BaseResponse) => {setSuccessResponse(response.responseMessage),setSuccessModal(true)},
            onError: (response: BaseResponse) => {setResponse(response.responseMessage),setModalVisible(true)},
        })
    );
    dispatch(auth.mutation.setUserEmail(formik.values.userEmail))
};

  const formik = useFormik({
    onSubmit: handleSubmit,
    initialValues: ResetPasswordRequestInit,
    validationSchema: forgotPasswordSchema,
});
    const navigate = useNavigate();

  return (
    <div className="p-5 space-y-5">
      <Textfield
        label="Email"
        name={"userEmail"}
        formik={formik}
        error={formik.errors.userEmail}
        type="email"
        placeholder="Enter your email"
      />

      <Button
        label="Reset Password"
        className="w-full mt-5"
        state="primary"
        onClick={() => formik.handleSubmit()}
        isLoading={authState.loading}
        disabled={!formik.isValid || authState.loading}
      />
          
      <div onClick={() => navigate(RouteConstant.auth.login.path)} className="pt-8 right-0 w-full cursor-pointer justify-end flex items-center">
              <FaAngleLeft className="text-tertiary" />
              <p className=" text-sm text-tertiary ">Back to login</p>
      </div>
      <Modal
        text={successResponse}
        type="success"
        modal={successModal}
        buttonLabel="Proceed"
        onClose={() =>
          navigate(RouteConstant.auth.resetPassword.path, {
            state: { userEmail: formik.values.userEmail },
          })
        }
        onClick={() =>
          navigate(RouteConstant.auth.resetPassword.path, {
            state: { userEmail: formik.values.userEmail },
          })
        }
      />
      <Modal
        // title="Signup Failed"
        text={response}
        type="error"
        modal={modalVisible}
        onClose={() => setModalVisible(false)}
        buttonLabel="Close"
        onClick={() => setModalVisible(false)}
      />
    </div>
  );
};
